<template>
  <div class="ai_warn_list" v-loading="loading">
    <el-card class="box-card">
			<el-form :model="pageInfo" label-width="80" class="whereclass">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('control.start_end_time')" prop="date">
              <el-date-picker
                v-model="date"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                :range-separator="$t('control.to')"
                :start-placeholder="$t('control.start_date')"
                :end-placeholder="$t('control.over_date')"
                @change="clearChange"
                >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('alarm.warn_type')" prop="type">
              <el-select v-model="pageInfo.type" :placeholder="$t('alarm.select_warn_type')">
                <el-option
                  v-for="item in whereOption.typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('alarm.reception')" prop="ste">
              <el-select v-model="pageInfo.ste">
                <el-option
                  v-for="item in whereOption.steOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">{{$t('control.search')}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>

			</el-form>
		</el-card>

    <div class="body_con">
      <el-row :gutter="20">
        <el-col :span="16">
          <el-table :data="tableData" style="width: 100%" @row-click="openDetails">
            <el-table-column prop="target_begin_time" :label="$t('ai.warn_time')" width="140"></el-table-column>
            <el-table-column prop="title" :label="$t('ai.warn_camera')"></el-table-column>
            <el-table-column prop="number" :label="$t('ai.camera_number')"></el-table-column>
            <el-table-column prop="target_name" :label="$t('ai.warn_desc')"> </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageInfo.page"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageInfo.pageSize"
            layout="sizes, total, prev, pager, next, jumper"
            :total="cnt_all"
          >
          </el-pagination>
        </el-col>
        <el-col :span="8">
          <div class="pic_view"><img :src="nowBaojingPic" /></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import aiListApi from "@/api/aivideo/aiList"
export default {
  name: "deviceList",
  props: {
    userId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      whereOption: {
        steOptions: [
          {
            value: '0',
            label: this.$t('ai.arrSte')[0]
          },
          {
            value: '1',
            label: this.$t('ai.arrSte')[1]
          },
          {
            value: '2',
            label: this.$t('ai.arrSte')[2]
          }
        ],
        typeOptions: [
          {
            value: '0',
            label: this.$t('ai.typeArr')[0]
          },
          {
            value: '1',
            label: this.$t('ai.typeArr')[1]
          },
          {
            value: '2',
            label: this.$t('ai.typeArr')[2]
          }
        ]
      },
      date: ['',''],
      pageInfo: {
        page: 1,
        pageSize: 10,
        begin_time:'',
        end_time:'',
        type:'',
        ste:''
      },
      cnt_all: 0,
      nowBaojingPic: ''
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.loading = true;
      this.pageInfo.page = pageIndex;
      this.pageInfo.begin_time = this.date[0].toString();
      this.pageInfo.end_time = this.date[1].toString();
      // console.log('this.pageInfo',this.pageInfo)
      aiListApi.getAiListApi(this.pageInfo).then((res) => {
        this.loading = false;
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.tableData = resData.list;
          if(resData.list.length){
            this.nowBaojingPic = resData.list[0].picture
          }
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openDetails (row) {
      this.nowBaojingPic = row.picture
    },
    clearChange(value) {
      if (!value) {
        this.$nextTick(() => {
          this.date = ''
        })
      }
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.ai_warn_list {
  width: 100%;
  height:100%;
  .el-card__body{
    padding-bottom: 5px !important;
  }
  .whereclass {
    .el-input__inner{
      height:34px !important;
      line-height: 34px !important;
      width:250px !important;
      .el-range-separator{
        line-height: 26px !important;
      }
    }
  }
  .body_con{
    .pic_view{
      margin-top:50px;
      img{
        width:100%;
        height:auto;
      }
    }
  }
}
</style>
